import { connect } from 'react-redux';
import { BreadcrumbsComponent } from './Breadcrumbs.component';
import { generateBreadcrumbs } from 'shared/store/selectors/admission.selector';
import { ROUTES } from 'shared/constants';

const mapStateToProps = ({ admission }, { pathParts, initialWorkspaceId = null }) => {
  return {
    path: generateBreadcrumbs(admission, { pathParts, initialWorkspaceId }),
    categoryPath: ROUTES.ADMISSION_CATEGORIES,
    rootPath: ROUTES.ADMISSION,
  };
};

export const AdmissionBreadcrumbs = connect(mapStateToProps)(BreadcrumbsComponent);
